import { Logger } from '@bancobarigui/front-end-logger';

let logger = null as unknown as Logger;

if (typeof window !== 'undefined') {
  logger = new Logger({});
}

export default logger;
